import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

import { FetchPayments } from '../exact.actions';
import { ExactState } from '../exact.state';

@Component({
    selector: 'app-exact-payments',
    templateUrl: './exact-payments.component.html',
    styleUrls: ['./exact-payments.component.scss'],
})
export class ExactPaymentsComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(ExactState.loggedIn) loggedIn$: Observable<boolean>;
    @Select(ExactState.payments) payments$: Observable<any[]>;
    filter: string;
    isset = true;

    constructor(private store: Store) {}

    ngOnInit(): void {
        this.subscriptions.add(
            this.loggedIn$.subscribe((loggedIn) => {
                if (loggedIn) {
                    this.store.dispatch(new FetchPayments()).subscribe();
                }
            }),
        );
    }

    checkCredentials(set: boolean) {
        this.isset = set;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
